import React, { useState } from 'react';
import {
    Box,
    Button,
    Container,
    Grid,
    Typography,
    Paper,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Chip,
    IconButton,
} from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import FilterListIcon from '@mui/icons-material/FilterList';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import VisibilityIcon from '@mui/icons-material/Visibility';
import RouteIcon from '@mui/icons-material/Route';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SpeedIcon from '@mui/icons-material/Speed';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';

// ─── Mock Data ────────────────────────────────────────────────────────────────

const statCards = [
    { label: 'Total Routes', value: '138', sub: '— vs Previous Period', up: null, color: '#1976d2', bg: '#e3f2fd', icon: <RouteIcon sx={{ fontSize: 22, color: '#1976d2' }} /> },
    { label: 'Total Schedules', value: '612', sub: '— vs Previous Period', up: null, color: '#2e7d32', bg: '#e8f5e9', icon: <CalendarMonthIcon sx={{ fontSize: 22, color: '#2e7d32' }} /> },
    { label: 'Total Revenue (MTD)', value: 'Rs. 124,560,850', sub: '▲ 12.5% vs Previous Period', up: true, color: '#5c35a0', bg: '#ede7f6', icon: <AttachMoneyIcon sx={{ fontSize: 22, color: '#5c35a0' }} /> },
    { label: 'Avg Load Factor', value: '68.4%', sub: '▲ 3.6% vs Previous Period', up: true, color: '#ed6c02', bg: '#fff3e0', icon: <SpeedIcon sx={{ fontSize: 22, color: '#ed6c02' }} /> },
    { label: 'Avg Revenue per Trip', value: 'Rs. 4,152.03', sub: '▲ 8.3% vs Previous Period', up: true, color: '#d32f2f', bg: '#ffebee', icon: <PeopleAltIcon sx={{ fontSize: 22, color: '#d32f2f' }} /> },
];

const statusColor = (s) => {
    if (s === 'High') return { backgroundColor: '#e8f5e9', color: '#2e7d32' };
    if (s === 'Medium') return { backgroundColor: '#fff3e0', color: '#ed6c02' };
    return { backgroundColor: '#ffebee', color: '#d32f2f' };
};

const routeRows = [
    { code: 'R-001', name: 'Colombo – Kandy', trips: 1256, revenue: 18750600, avgRev: 4120.50, passengers: 23450, load: 72.5, growth: 10.2, up: true, onTime: 92.3, topSch: 'SCH-001-06:00', status: 'High' },
    { code: 'R-017', name: 'Kandy – Kurunegala', trips: 1102, revenue: 12980450, avgRev: 3654.20, passengers: 19870, load: 68.9, growth: 8.5, up: true, onTime: 90.1, topSch: 'SCH-017-07:00', status: 'High' },
    { code: 'R-025', name: 'Kurunegala – Puttalam', trips: 986, revenue: 9845230, avgRev: 3221.40, passengers: 16320, load: 64.2, growth: 5.3, up: true, onTime: 88.7, topSch: 'SCH-025-08:00', status: 'Medium' },
    { code: 'R-027', name: 'Puttalam – Chilaw', trips: 876, revenue: 7654120, avgRev: 2916.70, passengers: 14450, load: 60.1, growth: 2.1, up: true, onTime: 85.4, topSch: 'SCH-027-07:30', status: 'Medium' },
    { code: 'R-003', name: 'Kandy – Matale', trips: 1045, revenue: 7320500, avgRev: 2692.10, passengers: 13980, load: 62.7, growth: 1.2, up: false, onTime: 87.2, topSch: 'SCH-003-06:30', status: 'Medium' },
    { code: 'R-042', name: 'Colombo – Negombo', trips: 920, revenue: 6540230, avgRev: 2580.30, passengers: 13200, load: 58.4, growth: 0.8, up: true, onTime: 84.1, topSch: 'SCH-042-07:00', status: 'Medium' },
    { code: 'R-055', name: 'Galle – Matara', trips: 780, revenue: 5870450, avgRev: 2340.20, passengers: 11800, load: 55.3, growth: 0.3, up: true, onTime: 82.6, topSch: 'SCH-055-08:30', status: 'Medium' },
    { code: 'R-061', name: 'Colombo – Ratnapura', trips: 654, revenue: 4980230, avgRev: 2210.50, passengers: 10450, load: 50.2, growth: 1.5, up: false, onTime: 79.3, topSch: 'SCH-061-09:00', status: 'Medium' },
    { code: 'R-072', name: 'Kandy – Nuwara Eliya', trips: 612, revenue: 4560120, avgRev: 2100.30, passengers: 9870, load: 48.6, growth: 2.8, up: false, onTime: 76.5, topSch: 'SCH-072-06:00', status: 'Medium' },
    { code: 'R-080', name: 'Colombo – Kalutara', trips: 598, revenue: 3980450, avgRev: 1980.70, passengers: 9120, load: 45.3, growth: 3.2, up: false, onTime: 74.8, topSch: 'SCH-080-07:30', status: 'Medium' },
    { code: 'R-085', name: 'Matara – Akuressa', trips: 542, revenue: 2145300, avgRev: 2152.60, passengers: 3960, load: 38.2, growth: 12.3, up: false, onTime: 72.1, topSch: 'SCH-085-09:00', status: 'Low' },
    { code: 'R-101', name: 'Hambantota – Tangalle', trips: 488, revenue: 1876450, avgRev: 1929.80, passengers: 3450, load: 35.6, growth: 13.6, up: false, onTime: 68.3, topSch: 'SCH-101-10:00', status: 'Low' },
    { code: 'R-110', name: 'Monaragala – Badulla', trips: 456, revenue: 1654200, avgRev: 1789.90, passengers: 2980, load: 32.8, growth: 14.8, up: false, onTime: 66.5, topSch: 'SCH-110-11:00', status: 'Low' },
    { code: 'R-118', name: 'Batticaloa – Ampara', trips: 432, revenue: 1452300, avgRev: 1612.70, passengers: 2620, load: 30.1, growth: 16.2, up: false, onTime: 64.2, topSch: 'SCH-118-12:00', status: 'Low' },
    { code: 'R-125', name: 'Mannar – Talaimannar', trips: 398, revenue: 1105600, avgRev: 1387.60, passengers: 1980, load: 28.7, growth: 18.1, up: false, onTime: 61.9, topSch: 'SCH-125-13:00', status: 'Low' },
    { code: 'R-130', name: 'Jaffna – Kilinochchi', trips: 345, revenue: 980450, avgRev: 1265.30, passengers: 1780, load: 26.4, growth: 19.5, up: false, onTime: 59.2, topSch: 'SCH-130-07:00', status: 'Low' },
    { code: 'R-135', name: 'Vavuniya – Mullaitivu', trips: 298, revenue: 845230, avgRev: 1134.80, passengers: 1540, load: 24.1, growth: 21.3, up: false, onTime: 57.8, topSch: 'SCH-135-08:00', status: 'Low' },
    { code: 'R-138', name: 'Trincomalee – Batticaloa', trips: 265, revenue: 723450, avgRev: 1023.60, passengers: 1320, load: 22.5, growth: 23.7, up: false, onTime: 55.4, topSch: 'SCH-138-09:30', status: 'Low' },
];

const keyRouteRows = routeRows.slice(0, 9).map((r, i) => ({ ...r, rank: i + 1 }));

const scheduleRows = [
    { code: 'SCH-001-06:00', route: 'R-001', depTime: '06:00', trips: 62, avgRev: 5214.60, load: 78.4, onTime: 94.3, status: 'High' },
    { code: 'SCH-017-07:00', route: 'R-017', depTime: '07:00', trips: 56, avgRev: 4862.30, load: 75.1, onTime: 93.2, status: 'High' },
    { code: 'SCH-025-08:00', route: 'R-025', depTime: '08:00', trips: 48, avgRev: 4521.90, load: 70.2, onTime: 91.5, status: 'High' },
    { code: 'SCH-003-06:30', route: 'R-003', depTime: '06:30', trips: 57, avgRev: 4310.50, load: 73.6, onTime: 92.1, status: 'High' },
    { code: 'SCH-027-07:30', route: 'R-027', depTime: '07:30', trips: 50, avgRev: 4125.20, load: 66.8, onTime: 88.7, status: 'Medium' },
    { code: 'SCH-001-18:00', route: 'R-001', depTime: '18:00', trips: 54, avgRev: 3985.70, load: 63.2, onTime: 89.3, status: 'Medium' },
    { code: 'SCH-017-18:30', route: 'R-017', depTime: '18:30', trips: 52, avgRev: 3842.10, load: 62.1, onTime: 87.9, status: 'Medium' },
    { code: 'SCH-025-18:00', route: 'R-025', depTime: '18:00', trips: 45, avgRev: 3612.40, load: 58.3, onTime: 85.6, status: 'Medium' },
    { code: 'SCH-085-09:00', route: 'R-085', depTime: '09:00', trips: 32, avgRev: 2152.80, load: 38.2, onTime: 72.1, status: 'Low' },
    { code: 'SCH-101-10:00', route: 'R-101', depTime: '10:00', trips: 28, avgRev: 1929.80, load: 35.6, onTime: 68.3, status: 'Low' },
];

const usePagination = (defaultRows = 10) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(defaultRows);
    return {
        page, rowsPerPage,
        handleChangePage: (_, p) => setPage(p),
        handleChangeRowsPerPage: (e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); },
        startIndex: page * rowsPerPage,
    };
};

const RouteSchedulePage = () => {
    const [depot, setDepot] = useState('');
    const [period, setPeriod] = useState('');
    const [status, setStatus] = useState('');
    const [topN, setTopN] = useState('20');

    const mainPag = usePagination(10);
    const keyPag = usePagination(10);
    const schPag = usePagination(10);

    const thSx = { py: 1 };
    const tdSx = { py: 0 };

    return (
        <Container component="main" maxWidth={false} sx={{ py: 0, px: { xs: 2, sm: 3 } }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>

                {/* ── Page Header ── */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 3, flexWrap: 'wrap', gap: 2 }}>
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>Route &amp; Schedule Performance</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Button variant="outlined" startIcon={<CalendarTodayIcon />} endIcon={<KeyboardArrowDownIcon />}
                            sx={{ borderRadius: '4px', textTransform: 'none', fontWeight: 600, height: 38, fontSize: 13 }}>
                            01 May 2026 – 31 May 2026
                        </Button>
                        <Button variant="outlined" startIcon={<FilterListIcon />}
                            sx={{ borderRadius: '4px', textTransform: 'none', fontWeight: 600, height: 38 }}>
                            Filters
                        </Button>
                    </Box>
                </Box>

                {/* ── Stat Cards ── */}
                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: 'repeat(2,1fr)', md: 'repeat(5,1fr)' },
                    gap: 2,
                    width: '100%',
                    mb: 3,
                }}>
                    {statCards.map((card) => (
                        <Paper key={card.label} variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                <Box sx={{ backgroundColor: card.bg, borderRadius: 1.5, p: 0.5, display: 'flex', alignItems: 'center' }}>
                                    {card.icon}
                                </Box>
                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: 11, lineHeight: 1.3 }}>{card.label}</Typography>
                            </Box>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: card.color, lineHeight: 1.2, mb: 0.5, fontSize: { xs: 16, md: 14, lg: 16 } }}>
                                {card.value}
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                {card.up === true && <TrendingUpIcon sx={{ fontSize: 13, color: '#2e7d32' }} />}
                                {card.up === false && <TrendingDownIcon sx={{ fontSize: 13, color: '#d32f2f' }} />}
                                <Typography variant="caption" sx={{ color: card.up === true ? '#2e7d32' : card.up === false ? '#d32f2f' : '#888', fontWeight: 600, fontSize: 11 }}>
                                    {card.sub}
                                </Typography>
                            </Box>
                        </Paper>
                    ))}
                </Box>

                {/* ── Filter Bar ── */}
                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2,1fr)', md: 'repeat(4,1fr)' }, gap: 2, width: '100%', mb: 3 }}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Period</InputLabel>
                        <Select value={period} onChange={e => setPeriod(e.target.value)} label="Period">
                            <MenuItem value="daily">Daily</MenuItem>
                            <MenuItem value="weekly">Weekly</MenuItem>
                            <MenuItem value="monthly">Monthly</MenuItem>
                            <MenuItem value="mtd">MTD</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth size="small">
                        <InputLabel>Depot</InputLabel>
                        <Select value={depot} onChange={e => setDepot(e.target.value)} label="Depot">
                            <MenuItem value="all">All Depots</MenuItem>
                            <MenuItem value="colombo">Colombo Depot</MenuItem>
                            <MenuItem value="kandy">Kandy Depot</MenuItem>
                            <MenuItem value="kurunegala">Kurunegala Depot</MenuItem>
                            <MenuItem value="matara">Matara Depot</MenuItem>
                            <MenuItem value="galle">Galle Depot</MenuItem>
                            <MenuItem value="negombo">Negombo Depot</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth size="small">
                        <InputLabel>Status</InputLabel>
                        <Select value={status} onChange={e => setStatus(e.target.value)} label="Status">
                            <MenuItem value="all">All Status</MenuItem>
                            <MenuItem value="high">High</MenuItem>
                            <MenuItem value="medium">Medium</MenuItem>
                            <MenuItem value="low">Low</MenuItem>
                        </Select>
                    </FormControl>
                    <Button variant="outlined" startIcon={<FilterListIcon />}
                        sx={{ borderRadius: '4px', textTransform: 'none', fontWeight: 600, height: 40 }}>
                        More Filters
                    </Button>
                </Box>

                {/* ── Route Performance Summary Table (full width) ── */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>Route Performance Summary</Typography>
                    <FormControl size="small" sx={{ minWidth: 130 }}>
                        <Select value={topN} onChange={e => setTopN(e.target.value)}
                            sx={{ fontSize: 13, height: 32 }}>
                            <MenuItem value="10">Show Top 10</MenuItem>
                            <MenuItem value="20">Show Top 20</MenuItem>
                            <MenuItem value="50">Show Top 50</MenuItem>
                            <MenuItem value="all">Show All</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                <TableCell sx={thSx}>Route Code</TableCell>
                                <TableCell sx={thSx}>Route Name</TableCell>
                                <TableCell sx={thSx}>Total Trips</TableCell>
                                <TableCell sx={thSx}>Total Revenue (Rs.)</TableCell>
                                <TableCell sx={thSx}>Avg Revenue per Trip (Rs.)</TableCell>
                                <TableCell sx={thSx}>Total Passengers</TableCell>
                                <TableCell sx={thSx}>Load Factor (%)</TableCell>
                                <TableCell sx={thSx}>
                                    <Box>Growth %</Box>
                                    <Typography variant="caption" color="text.secondary">vs Prev. Period</Typography>
                                </TableCell>
                                <TableCell sx={thSx}>On-Time %</TableCell>
                                <TableCell sx={thSx}>Top Performing Schedule</TableCell>
                                <TableCell sx={thSx}>Status</TableCell>
                                <TableCell sx={thSx} align="right">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {routeRows
                                .slice(mainPag.startIndex, mainPag.startIndex + mainPag.rowsPerPage)
                                .map((row) => (
                                    <TableRow key={row.code} hover>
                                        <TableCell sx={{ ...tdSx, fontWeight: 600 }}>{row.code}</TableCell>
                                        <TableCell sx={tdSx}>{row.name}</TableCell>
                                        <TableCell sx={tdSx}>{row.trips.toLocaleString()}</TableCell>
                                        <TableCell sx={tdSx}>{row.revenue.toLocaleString()}</TableCell>
                                        <TableCell sx={tdSx}>{row.avgRev.toFixed(2)}</TableCell>
                                        <TableCell sx={tdSx}>{row.passengers.toLocaleString()}</TableCell>
                                        <TableCell sx={tdSx}>{row.load}%</TableCell>
                                        <TableCell sx={tdSx}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                                {row.up ? <TrendingUpIcon sx={{ fontSize: 13, color: '#2e7d32' }} /> : <TrendingDownIcon sx={{ fontSize: 13, color: '#d32f2f' }} />}
                                                <Typography variant="caption" sx={{ color: row.up ? '#2e7d32' : '#d32f2f', fontWeight: 600 }}>
                                                    {row.up ? '▲' : '▼'} {row.growth}%
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell sx={tdSx}>{row.onTime}%</TableCell>
                                        <TableCell sx={tdSx}>{row.topSch}</TableCell>
                                        <TableCell sx={tdSx}>
                                            <Chip label={row.status} size="small" sx={{ ...statusColor(row.status), fontWeight: 600, fontSize: 11 }} />
                                        </TableCell>
                                        <TableCell sx={tdSx} align="right">
                                            <IconButton size="small" color="primary"><VisibilityIcon sx={{ fontSize: 18 }} /></IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        showFirstButton showLastButton
                        component="div"
                        count={routeRows.length}
                        page={mainPag.page}
                        onPageChange={mainPag.handleChangePage}
                        rowsPerPage={mainPag.rowsPerPage}
                        onRowsPerPageChange={mainPag.handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                    />
                </TableContainer>

                {/* ── Bottom Row: Key Routes Snapshot + Schedule Performance (side by side) ── */}
                <Grid container sx={{ mt: 3, width: '100%' }}>

                    {/* Key Routes Snapshot */}
                    <Grid item xs={12} md={12} sx={{mb:3}}>
                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1.5 }}>Key Routes Snapshot</Typography>
                        <TableContainer component={Paper}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                        <TableCell sx={thSx}>Route Code</TableCell>
                                        <TableCell sx={thSx}>Route Name</TableCell>
                                        <TableCell sx={thSx}>Revenue (Rs.)</TableCell>
                                        <TableCell sx={thSx}>Load Factor (%)</TableCell>
                                        <TableCell sx={thSx}>
                                            <Box>Growth %</Box>
                                            <Typography variant="caption" color="text.secondary">vs Prev. Period</Typography>
                                        </TableCell>
                                        <TableCell sx={thSx}>Rank</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {keyRouteRows
                                        .slice(keyPag.startIndex, keyPag.startIndex + keyPag.rowsPerPage)
                                        .map((row) => (
                                            <TableRow key={row.code} hover>
                                                <TableCell sx={{ ...tdSx, fontWeight: 600, fontSize: 12 }}>{row.code}</TableCell>
                                                <TableCell sx={{ ...tdSx, fontSize: 12 }}>{row.name}</TableCell>
                                                <TableCell sx={{ ...tdSx, fontSize: 12 }}>{row.revenue.toLocaleString()}</TableCell>
                                                <TableCell sx={{ ...tdSx, fontSize: 12 }}>{row.load}%</TableCell>
                                                <TableCell sx={{ ...tdSx, fontSize: 12 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                                        {row.up ? <TrendingUpIcon sx={{ fontSize: 12, color: '#2e7d32' }} /> : <TrendingDownIcon sx={{ fontSize: 12, color: '#d32f2f' }} />}
                                                        <Typography variant="caption" sx={{ color: row.up ? '#2e7d32' : '#d32f2f', fontWeight: 600 }}>
                                                            {row.up ? '▲' : '▼'} {row.growth}%
                                                        </Typography>
                                                    </Box>
                                                </TableCell>
                                                <TableCell sx={{ ...tdSx, fontSize: 12, fontWeight: 700 }}>{row.rank}</TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                            <TablePagination
                                showFirstButton showLastButton
                                component="div"
                                count={keyRouteRows.length}
                                page={keyPag.page}
                                onPageChange={keyPag.handleChangePage}
                                rowsPerPage={keyPag.rowsPerPage}
                                onRowsPerPageChange={keyPag.handleChangeRowsPerPage}
                                rowsPerPageOptions={[10, 25, 50]}
                            />
                        </TableContainer>
                    </Grid>

                    {/* Schedule Performance Summary */}
                    <Grid item xs={12} md={12}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>Schedule Performance Summary (Top 10 by Avg Revenue per Trip)</Typography>
                        </Box>
                        <TableContainer component={Paper}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                        <TableCell sx={thSx}>Schedule Code</TableCell>
                                        <TableCell sx={thSx}>Route Code</TableCell>
                                        <TableCell sx={thSx}>Departure Time</TableCell>
                                        <TableCell sx={thSx}>Total Trips</TableCell>
                                        <TableCell sx={thSx}>Avg Revenue per Trip (Rs.)</TableCell>
                                        <TableCell sx={thSx}>Load Factor (%)</TableCell>
                                        <TableCell sx={thSx}>On-Time %</TableCell>
                                        <TableCell sx={thSx}>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {scheduleRows
                                        .slice(schPag.startIndex, schPag.startIndex + schPag.rowsPerPage)
                                        .map((row) => (
                                            <TableRow key={row.code} hover>
                                                <TableCell sx={{ ...tdSx, fontWeight: 600, fontSize: 12 }}>{row.code}</TableCell>
                                                <TableCell sx={{ ...tdSx, fontSize: 12 }}>{row.route}</TableCell>
                                                <TableCell sx={{ ...tdSx, fontSize: 12 }}>{row.depTime}</TableCell>
                                                <TableCell sx={{ ...tdSx, fontSize: 12 }}>{row.trips}</TableCell>
                                                <TableCell sx={{ ...tdSx, fontSize: 12 }}>{row.avgRev.toFixed(2)}</TableCell>
                                                <TableCell sx={{ ...tdSx, fontSize: 12 }}>{row.load}%</TableCell>
                                                <TableCell sx={{ ...tdSx, fontSize: 12 }}>{row.onTime}%</TableCell>
                                                <TableCell sx={{ ...tdSx, fontSize: 12 }}>
                                                    <Chip label={row.status} size="small" sx={{ ...statusColor(row.status), fontWeight: 600, fontSize: 11 }} />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                            <TablePagination
                                showFirstButton showLastButton
                                component="div"
                                count={scheduleRows.length}
                                page={schPag.page}
                                onPageChange={schPag.handleChangePage}
                                rowsPerPage={schPag.rowsPerPage}
                                onRowsPerPageChange={schPag.handleChangeRowsPerPage}
                                rowsPerPageOptions={[10, 25, 50]}
                            />
                        </TableContainer>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                            <Button size="small" sx={{ textTransform: 'none', color: '#1976d2', fontWeight: 600, p: 0 }}>
                                View All Schedules
                            </Button>
                        </Box>
                    </Grid>

                </Grid>

            </Box>
        </Container>
    );
};

export default RouteSchedulePage;